<template>
  <div class="col-xl-8 xl-100">
    <px-card :title="title">
      <div class="card-body">
        <apexchart
          type="line"
          height="330"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </px-card>
  </div>
</template>

<script>
export default {
  name: "sales-month-chart",
  props: {
    stats: { type: Object, required: true },
    title: { type: String, default: "Sales per month" }
  },
  computed: {
    series() {
      return [
        { name: "Revenue", type: "column", data: this.stats.monthly.revenue },
        { name: "Orders", type: "line", data: this.stats.monthly.orders }
      ];
    },
    chartOptions() {
      const symbol = this.stats.currencySymbol;
      return {
        chart: {
          height: 330,
          type: "line",
          toolbar: { show: false },
          fontFamily: "inherit"
        },
        stroke: { width: [0, 3], curve: "smooth" },
        colors: ["#4680ff", "#f73164"],
        plotOptions: {
          bar: { columnWidth: "50%", borderRadius: 4 }
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: this.stats.monthly.labels,
          labels: { style: { fontSize: "11px" } }
        },
        yaxis: [
          {
            title: { text: "Revenue" },
            labels: {
              formatter: (val) => (symbol ? symbol + " " : "") + Math.round(val)
            }
          },
          {
            opposite: true,
            title: { text: "Orders" },
            labels: {
              formatter: (val) => (Number.isInteger(val) ? String(val) : "")
            }
          }
        ],
        legend: { position: "top", horizontalAlign: "right" },
        grid: { borderColor: "#f1f1f1" },
        tooltip: { shared: true, intersect: false }
      };
    }
  }
};
</script>

<style></style>
